import { Check } from 'lucide-react';
import { useAnimationLoop } from './useOnboardingAnim';
import { DEMO_ROOT_CLASS } from './onboardingLayout';

const READY_PHASES = [600, 600, 600, 600, 600, 600, 1500];

const RECAP_ITEMS = [
  'Patients',
  'Hold the mic',
  'Review & save',
  'Tasks & flow sheet',
  'Session tabs',
  'End shift handover',
];

export default function ReadyDemoAnimation() {
  const phase = useAnimationLoop(READY_PHASES);

  return (
    <div className={DEMO_ROOT_CLASS}>
      <div className="relative flex h-full w-full flex-col items-center justify-center px-1">
      <div className="relative mb-2 flex h-16 w-16 items-center justify-center sm:mb-3 sm:h-20 sm:w-20">
        <div className="onboarding-confetti absolute inset-0" aria-hidden />
        <div
          className={`relative flex h-16 w-16 items-center justify-center rounded-full bg-[#1E40AF] shadow-lg transition-transform duration-500 sm:h-20 sm:w-20 ${
            phase >= 0 ? 'onboarding-check-pop scale-100' : 'scale-75'
          }`}
        >
          <Check className="h-8 w-8 text-white sm:h-10 sm:w-10" strokeWidth={3} />
        </div>
      </div>
      <div className="w-full max-w-[220px] space-y-0.5 sm:space-y-1">
        {RECAP_ITEMS.map((item, index) => (
          <div
            key={item}
            className={`flex items-center gap-2 rounded-lg px-2 py-0.5 text-[8px] transition-all duration-400 sm:py-1 sm:text-[9px] ${
              phase > index ? 'bg-success-light text-success-dark' : 'bg-gray-50 text-gray-400'
            }`}
          >
            <span
              className={`flex h-4 w-4 items-center justify-center rounded-full text-[8px] font-bold transition-colors duration-300 ${
                phase > index ? 'bg-success text-white' : 'bg-gray-200 text-gray-500'
              }`}
            >
              {phase > index ? '✓' : index + 1}
            </span>
            {item}
          </div>
        ))}
      </div>
      </div>
    </div>
  );
}
